import { useMutation, useQueryClient } from '@tanstack/react-query';
import { axios } from '@/services/axios';

const useApproveCompany = (companyId) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async ({ approvalData, asTrial }) => {
            if (!companyId) throw new Error('No companyId');
            const url = `/company/${companyId}/approval${asTrial ? '?trial=true' : ''}`;
            const res = await axios.put(url, approvalData);
            return res.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries(['companies']);
        },
        staleTime: 0,
    });
};

export default useApproveCompany;
